import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 group cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center text-xl">
                🍉
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                吃瓜爆料
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              最新吃瓜爆料免费真实资讯平台，实时更新今日吃瓜热点与真实内幕爆料。吃的是瓜，追的是真相。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">更多分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">关于我们</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-fill text-background-50 text-sm"></i>
              </a>
              <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-fill text-background-50 text-sm"></i>
              </a>
              <a href="https://douyin.com" target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-600 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-fill text-background-50 text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 吃瓜爆料. 本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}